<template>
  <div class="login">
    <!--浏览器兼容提示-->
    <div class="tip">
      <div class="warn">温馨提示：您当前的浏览器版本过低，请使用其他浏览器</div>
    </div>
    <div class="login-box">
      <div class="login-left"></div>
      <div class="login-right">
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane key="1" tab="手机号登录">
            <div class="form">
              <div class="public">
                <input type="text" v-model.trim="phone" placeholder="请输入手机号" maxlength="11" />
              </div>

              <div class="verification-code">
                <input type="text" class="code" placeholder="短信验证码" @keyup.enter="loginRequest()" v-model.trim="code"
                  maxlength="6" />

                <div class="code-img">
                  <a-button :disabled="isStart" style="height: 100%" @click="getCodeFun()" block>获取 {{ isStart ? "(" +
                    second + ")" : "" }}</a-button>
                </div>
              </div>

              <a-button type="primary" class="btn" :loading="loading" @click="loginRequest()" block>登录
              </a-button>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="证件号登录" force-render>
            <a-alert message="仅供退休人员使用" banner />
            <div class="form">
              <div class="public">
                <input type="text" v-model.trim="username" placeholder="请输入证件号" />
              </div>

              <div class="verification-code">
                <input type="password" placeholder="请输入密码" @keyup.enter="IDNumberloginRequest()"
                  v-model.trim="password" />
              </div>

              <a-button type="primary" class="btn" :loading="loading" @click="IDNumberloginRequest()" block>登录
              </a-button>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <!--相同手机号人员列表弹窗-->
    <a-modal title="请选择其中一个进行登录" centered v-model="visible" :footer="false">
      <div class="list" v-for="item in someList" :key="item.userNo">
        <a-card :title="item.userName">
          <a slot="extra" @click="onSelect(item)">选择</a>
          <p>{{ item.idNumber }}</p>
        </a-card>
      </div>
      <a-empty v-if="someList.length <= 0" />
    </a-modal>
  </div>
</template>
<script>
import { message } from "ant-design-vue";
import base from "@/assets/base/base.js";
import { getCode, userLogin, userRegister } from "@/api/login";
export default {
  name: "login",
  data() {
    return {
      code: "",
      phone: "",
      img: "",
      username: "",
      password: "",
      loading: false,
      isStart: false,
      second: 60,
      visible: false,
      someList: [],
    };
  },
  methods: {
    //选择身份登录
    async onSelect(item) {
      this.visible = false;

      let params = {
        type: "user_no",
        username: item.userNo,
      };

      const { code, data, msg } = await userLogin(params);
      if (code == 200) {
        sessionStorage.setItem("token", data.token);
        sessionStorage.setItem("userInfo", JSON.stringify(data.e));
        this.$store.commit("login/changLogin", true);
        // 检查是否有保存的重定向路径
        const redirectUrl = sessionStorage.getItem("redirectUrl");
        if (redirectUrl) {
          sessionStorage.removeItem("redirectUrl");
          this.$router.push(redirectUrl);
        } else {
          this.$router.push("/index");
        }
      } else if (code == 3015) {
        message.warning("不存在该用户，请在公众号或者浙大钉中注册");
      } else if (code == 3016) {
        //完善身份信息
        sessionStorage.setItem("token", data.token);
        sessionStorage.setItem("userInfo", JSON.stringify(data.e));
        let that = this;
        this.$confirm({
          title: "身份信息不全",
          content: "请完善身份信息，否则无法使用本系统",
          onOk() {
            that.$router.push("/improveInfo");
          },
          onCancel() { },
        });
      } else {
        message.warning(msg);
      }
    },
    callback(key) {
      this.username = "";
      this.password = "";
      this.code = "";
      this.phone = "";
    },

    forgetPasswordJump() {
      this.$router.push("forgetPassword");
    },
    register() {
      this.$router.push("register");
    },

    async getCodeFun() {
      if (!base.isPoneAvailable(this.phone)) {
        message.warning("请输入正确的手机号");
        return;
      }

      const { code, msg } = await getCode(this.phone);
      if (code == 200) {
        message.success(msg);
        this.startTime();
      }
    },
    startTime() {
      this.second = 60;
      this.isStart = true;
      this.setTime = setInterval(() => {
        if (this.second > 1) {
          this.second--;
        } else {
          clearInterval(this.setTime);
          this.isStart = false;
        }
      }, 1000);
    },
    //手机号登录
    async loginRequest() {
      if (!this.phone || !this.code) {
        if (!this.phone) {
          message.warning("请输入手机号");
        }
        if (!this.code) {
          message.warning("请输入验证码");
        }
        return;
      }

      let params = {
        phone: this.phone,
        code: this.code,
        type: "wechat_phone",
      };
      this.loading = true;
      userLogin(params)
        .then((res) => {

          let { code, data, msg } = res;
          this.loading = false;
          if (code == 200) {
            sessionStorage.setItem("token", data.token);
            sessionStorage.setItem("userInfo", JSON.stringify(data.e));
            this.$store.commit("login/changLogin", true);
            // 检查是否有保存的重定向路径
            const redirectUrl = sessionStorage.getItem("redirectUrl");
            if (redirectUrl) {
              sessionStorage.removeItem("redirectUrl");
              this.$router.push(redirectUrl);
            } else {
              this.$router.push("/index");
            }

          } else if (code == 3015) {
            message.warning("不存在该用户，请在公众号或者浙大钉中注册");
            // this.addUser();
          } else if (code == 3016) {
            //完善身份信息
            sessionStorage.setItem("token", data.token);
            sessionStorage.setItem("userInfo", JSON.stringify(data.e));
            let that = this;
            this.$confirm({
              title: "身份信息不全",
              content: "请完善身份信息，否则无法使用本系统",
              onOk() {
                that.$router.push("/improveInfo");
              },
              onCancel() { },
            });
          } else if (code == 3018) {
            //处理相同手机号的多个账号

            this.someList = data;
            let that = this;
            this.$confirm({
              title: "提示",
              content: "该手机号有多个用户，请选择其中一个进行登录",
              onOk() {
                that.visible = true;
              },
              onCancel() { },
            });
          } else {
            message.warning(msg);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //证件号登录
    async IDNumberloginRequest() {
      if (!this.username || !this.password) {
        if (!this.username) {
          message.warning("请输入证件号");
        }
        if (!this.password) {
          message.warning("请输入密码");
        }
        return;
      }
      let params = {
        password: this.password,
        type: "user_account",
        username: this.username,
      };

      const { code, data, msg } = await userLogin(params);
      if (code == 200) {
        sessionStorage.setItem("token", data.token);
        sessionStorage.setItem("userInfo", JSON.stringify(data.e));
        this.$store.commit("login/changLogin", true);
        // 检查是否有保存的重定向路径
        const redirectUrl = sessionStorage.getItem("redirectUrl");
        if (redirectUrl) {
          sessionStorage.removeItem("redirectUrl");
          this.$router.push(redirectUrl);
        } else {
          this.$router.push("/index");
        }
      } else if (code == 3015) {
        message.warning("不存在该用户，请在公众号或者浙大钉中注册");
        //this.addUser();
      } else if (code == 3016) {
        //完善身份信息
        sessionStorage.setItem("token", data.token);
        sessionStorage.setItem("userInfo", JSON.stringify(data.e));
        let that = this;
        this.$confirm({
          title: "身份信息不全",
          content: "请完善身份信息，否则无法使用本系统",
          onOk() {
            that.$router.push("/improveInfo");
          },
          onCancel() { },
        });
      } else {
        message.warning(msg);
      }
    },

    //注册
    async addUser() {
      let params = {
        phone: this.phone,
        certificateType: "0",
        birthday: "",
        classNo: "",
        college: "",
        country: "156",
        gender: "1",
        idCard: "",
        jobNo: "",
        passport: "",
        userName: "",
      };
      const { code, data, msg } = await userRegister(params);
      if (code == 200) {
        sessionStorage.setItem("token", data.token);
        sessionStorage.setItem("userInfo", JSON.stringify(data.e));
        this.$store.commit("login/changLogin", true);
        // 检查是否有保存的重定向路径
        const redirectUrl = sessionStorage.getItem("redirectUrl");
        if (redirectUrl) {
          sessionStorage.removeItem("redirectUrl");
          this.$router.push(redirectUrl);
        } else {
          this.$router.push("/index");
        }
      } else if (code == 3016) {
        message.warning("请在后台完善身份信息");
      } else {
        message.warning(msg);
      }
    },
  },
  created() {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userInfo");
  },
  mounted() {
    var dom = document.querySelector(".tip");
    if (window.ActiveXObject != undefined) {
      dom.style.display = "block";
    } else {
      dom.style.display = "none";
    }
  },
};
</script>
<style scoped>
.login {
  min-height: 750px;
  min-width: 700px;
  font-size: 16px;
  overflow-x: auto;
  overflow-y: hidden;
}

.login .top-title {
  padding-top: 100px;
  font-size: 50px;
  text-align: center;
  color: #fff;
  display: none;
}

.login .login-box {
  /* position: absolute;
    top: 50%;
    left: 50%; */
  width: 700px;
  margin: 155px auto 0;
  display: flex;
  align-items: center;
  /* margin-top: -220px;
    margin-left: -350px; */
  /* padding: 20px 50px 30px; */
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.login-left {
  height: 440px;
  width: 300px;
  background-image: url("../assets/img/login.jpg");
  background-size: 100% 100%;
  background-blend-mode: normal;
  border-radius: 20px 0 0 20px;
  mix-blend-mode: normal;
}

.login-right {
  height: 440px;
  width: 400px;
  padding: 40px;
  box-sizing: border-box;
  border-radius: 0 20px 20px 0;
}

.login .login-box .title {
  margin: 0 auto 20px;
  color: #333;
  padding: 10px;
  text-align: center;
  font-size: 20px;
}

.public {
  position: relative;
  width: 100%;
  height: 50px;
  margin-bottom: 20px;
  vertical-align: middle;
}

input {
  height: 50px;
  width: 100%;
  box-sizing: border-box;
  padding: 4px 12px 4px 35px;
  border-radius: 4px;
  outline: none;
  background-color: #f3f7f9;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

i {
  position: absolute;
  top: 14px;
  left: 10px;
  width: 18px;
  height: 25px;
  line-height: 25px;
  font-size: 18px;
  color: #969696;
}

.login .verification-code {
  position: relative;
  height: 50px;
}

.login .verification-code .code {
  position: absolute;
  left: 0;
  top: 0;
  width: 150px;
  padding: 0 10px 0 35px;
  border-radius: 4px;
}

.login .verification-code .code-img {
  position: absolute;
  right: 0;
  margin-left: 20px;
  width: 130px;
  height: 50px;
  border-radius: 4px;
  cursor: pointer;
  background-color: #fbfbfb;
}

.login .sign-in-button {
  line-height: 1.2;
  padding: 12px 20px;
  height: auto;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  outline: none;
  display: block;
  color: #fff;
  background: #13cb6e;
  box-shadow: 0 3px 6px rgba(19, 203, 110, 0.25);
}

.reset-link-box {
  color: #13cb6e;
  margin-top: 18px;
}

.reset-link-box span {
  font-size: 14px;
  display: inline-block;
  width: 49%;
  cursor: pointer;
}

.forget-password {
  color: #999;
  text-align: right !important;
}

.tip {
  position: relative;
  z-index: 3;
  height: 100%;
  width: 100%;
  background: #fff;
}

.tip .warn {
  margin: 100px auto;
  height: 100px;
  width: 900px;
  font-size: 24px;
  text-align: center;
  color: #fff;
  line-height: 80px;
  /* background-image: url("../assets/img/bg_tip.jpg"); */
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.btn {
  height: 45px;
  margin-top: 20px;
}

.form {
  margin-top: 20px;
}

.list {
  margin-top: 10px;
}
</style>